import { API_BASE_URL } from '../config';

const getFullUrl = (path: string) => {
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return `${API_BASE_URL}${path}`;
  }
  return path;
};

export async function checkShippingServiceability(pickup: string, delivery: string, weight: number = 0.5) {
  const query = new URLSearchParams({ pickup, delivery, weight: String(weight) });
  const res = await fetch(getFullUrl(`/api/shipping/serviceability?${query.toString()}`), {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Failed to check serviceability');
  }
  
  return res.json();
}
